<template src="./MenuList.html"> </template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'MenuList',
    props: {
        items: {
            required: true,
            type: Array
        }
    },
    data: function() {
        return {
            itemActive: null,
            subItemActive: null
        }
    },
    computed: {
        getItems() {
            return this.items.map((item, index) =>  {
                let act = {active: false}
                if (index == this.itemActive)
                   act = {active: true}
                return {...item, ...act}
            });
        }
    },
    methods: {
        
        ...mapActions({
            setMenuVariable: 'setMenuVariable'
        }),

        toggleActive: function(idx, i, variable) {
            this.subItemActive = idx;
            this.itemActive = i;
            this.$emit('input', variable);
        }
    },
    mounted() {
        this.subItemActive = 0;
        this.itemActive = 0;
        //this.$emit('input', 'totR');
    },
}
</script>

<style lang="scss" src="./MenuList.scss"> </style>